/* eslint-disable react/prop-types,max-len */
import React from 'react';
import { Stack, Button } from '@mui/material';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import LastPageIcon from '@mui/icons-material/LastPage';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import SearchIcon from '@mui/icons-material/Search';

const ControlButtons = ({
  currentIndex,
  sessionDetails,
  navigateToFirst,
  navigateToPrevious,
  navigateToNext,
  navigateToLast,
  handleOpenDialog,
}) => {
  return (
        <Stack direction="row" justifyContent="space-evenly" spacing={2} sx={{ marginY: '1rem' }}>
            <Button
                variant="contained"
                size="small"
                startIcon={<FirstPageIcon/>}
                disabled={currentIndex === 0}
                onClick={navigateToFirst}
            >
                First
            </Button>
            <Button
                variant="contained"
                size="small"
                startIcon={<NavigateBeforeIcon/>}
                disabled={currentIndex === 0}
                onClick={navigateToPrevious}
            >
                Previous
            </Button>
            <Button
                variant="contained"
                size="small"
                endIcon={<SearchIcon/>}
                disabled={currentIndex === sessionDetails.length - 1}
                onClick={handleOpenDialog}
            >
                Jump to a Clip
            </Button>
            <Button
                variant="contained"
                size="small"
                endIcon={<NavigateNextIcon/>}
                disabled={currentIndex === sessionDetails.length - 1}
                onClick={navigateToNext}
            >
                Next
            </Button>
            <Button
                variant="contained"
                size="small"
                endIcon={<LastPageIcon/>}
                disabled={currentIndex === sessionDetails.length - 1}
                onClick={navigateToLast}
            >
                Last
            </Button>
        </Stack>
  );
};

export default React.memo(ControlButtons);
